/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Sources_NoteInputs */



/**
* | output |
* | --- |
* | "Wundo reads the reports of earlier conversations in this series." |
*
* @param {Meeting_Sources_NoteInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_note = /** @type {((inputs?: Meeting_Sources_NoteInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_NoteInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo leest de verslagen van eerdere gesprekken in deze reeks mee.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo lit les comptes rendus des conversations précédentes de cette série.")
	return /** @type {LocalizedString} */ ("Wundo reads the reports of earlier conversations in this series.")
});